/* 🤖 this file was generated by svg-to-ts */
export const matIconArrowBackIos: {
  name: 'arrow-back-ios';
  data: string;
} = {
  name: 'arrow-back-ios',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17.51 3.87 15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z"/></svg>`
};
